import React, { useState } from 'react';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  mobileMenuIcon: {
    marginTop: '5px',
    marginRight: '5px',
    color: theme.palette.secondary.light,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  root: {
    height: '100vh',
    background: theme.palette.secondary.main,
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 30px 20px 50px',
    '& > *': {
      color: '#FFFFFF',
    },
  },
  closeButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  closeIcon: {
    fontWeight: 'bold',
  },
  title: {
    marginTop: '50px',
    fontSize: 36,
    fontWeight: 'bold',
    letterSpacing: '-0.04em',
  },
  subtitle: {
    fontWeight: 'bold',
    fontSize: 22,
    letterSpacing: '-0.04em',
  },
  navWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '60px',
    '& > a': {
      color: '#FFFFFF',
      fontSize: 32,
      fontWeight: 'bold',
      marginBottom: '25px',
    },
  },
  mlhCode: {
    marginTop: '15px',
    fontSize: 18,
    lineHeight: '23px',
    letterSpacing: '-0.03em',
  },
  login: {
    '& > div': {
      width: 'min-content',
      borderBottom: '2px solid white',
      float: 'left',
    },
    '& span': {
      fontSize: '32px',
      marginLeft: '10px',
    },
  },
}));

const SocialMediaIconWrapper = styled.div`
  & > a {
    margin-right: 20px;
  }
`;

const SocialMediaIcons = styled.img`
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

const MobileMenu = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setOpen(open);
  };

  return (
    <div className={classes.mobileMenuIcon}>
      <Button onClick={toggleDrawer(true)}>
        <MenuIcon className={classes.mobileMenuIcon} fontSize="large" />
      </Button>
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <div className={classes.root}>
          <Button onClick={toggleDrawer(false)} className={classes.closeButton}>
            <CloseIcon className={classes.closeIcon} fontSize="large" />
          </Button>
          <div className={classes.title}>Hack Western 7</div>
          <div className={classes.subtitle}>make anything, anywhere</div>
          <div className={classes.navWrapper}>
            {/* <Link
              className={classes.login}
              href="/login"
              onClick={toggleDrawer(false)}>
              <div>Login</div>
              <span>&rarr;</span>
            </Link> */}
            <Link href="#sponsors" onClick={toggleDrawer(false)}>
              Sponsors
            </Link>
            <Link href="#faq" onClick={toggleDrawer(false)}>
              FAQ
            </Link>
            <Link href="#contact" onClick={toggleDrawer(false)}>
              Contact
            </Link>
          </div>
          <SocialMediaIconWrapper>
            <Link
              href="https://www.instagram.com/hackwestern/"
              target="_Blank"
              onClick={toggleDrawer(false)}>
              <SocialMediaIcons
                src={require('./assets/_instagram-white.png')}
                alt="hwInstagram"
              />
            </Link>
            <Link
              href="https://www.facebook.com/hackwestern"
              target="_Blank"
              onClick={toggleDrawer(false)}>
              <SocialMediaIcons
                src={require('./assets/facebook-white.png')}
                alt="hwFacebook"
              />
            </Link>
            <Link
              href="https://www.linkedin.com/company/hack-western/about/"
              target="_Blank"
              onClick={toggleDrawer(false)}>
              <SocialMediaIcons
                src={require('./assets/linkedin-white.png')}
                alt="hwLinkedIn"
              />
            </Link>
            <Link
              href="https://twitter.com/hackwestern"
              target="_Blank"
              onClick={toggleDrawer(false)}>
              <SocialMediaIcons
                src={require('./assets/twitter-white.png')}
                alt="hwTwitter"
              />
            </Link>
          </SocialMediaIconWrapper>
          <Link
            href="https://static.mlh.io/docs/mlh-code-of-conduct.pdf"
            target="_Blank"
            onClick={toggleDrawer(false)}
            className={classes.mlhCode}>
            MLH Code of Conduct
          </Link>
        </div>
      </Drawer>
    </div>
  );
};

export default MobileMenu;
